<style scoped lang="scss">
.wrap {
  width: 100%;
  display: flex;
  margin-top: 42px;
  align-items: stretch;
}

.left {
  width: 411px;
  height: 325px;
  border: 1px solid #dcdfe6;
}

.item1 {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  height: 60px;
  margin-top: -50px;

  .icon {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: #419fff;
  }

  .txt {
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    color: #303133;
    margin-left: 12px;
  }
}

.item2 {
  width: 100%;
  height: 270px;

  //border: 1px solid #DCDFE6;
  .header {
    width: 411px;
    padding: 20px 15px 6px 15px;

    .title {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      color: #303133;
    }

    .circle {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #e6a23c;
      margin: 0 9px 0 13px;
    }

    .tag-left {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #606266;
    }

    .tag-right {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #606266;
    }
  }

  .reason {
    width: 100%;
    height: 270px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 15px;
    overflow: auto;
    margin-bottom: 10px;

    .reason__item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      margin-left: 15px;

      .content {
        //display: flex;
        //align-items: center;
        display: grid;
        grid-template-columns: 20px 150px 200px 120px;
        width: 100%;

        .sort {
          height: 17px;
          width: 17px;
          border-radius: 50%;
          color: white;
          background-color: #909399;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .title {
          font-size: 12px;
          line-height: 22px;
          color: #303133;
          margin-left: 10px;
          width: 150px;
        }

        //.label {
        //  color: #606266;
        //  margin-left: 8px;
        //  width: 120px;
        //  overflow: hidden;
        //}

        .chart {
          height: 8px;
          background-color: #419fff;
          margin-left: 8px;
          width: 200px;
          margin-top: 6px;
        }

        .label {
          font-size: 12px;
          line-height: 18px;
          color: #e6a23c;
          width: 120px;
          margin-left: 20px;
        }

        .label-l,
        .label-r {
          margin-left: 5px;
        }

        .label-r {
          color: #f56c6c;
        }
      }
    }
  }
}

.right {
  flex: 1;
  height: 325px;
  margin-left: 18px;
  border: 1px solid #dcdfe6;
  padding: 20px 28px 46px 28px;
  display: flex;

  .item2 {
    width: 100%;
    height: 300px;

    .header {
      color: #303133;
      font-size: 16px;
      margin-top: -10px;
    }

    #tableChart {
      width: 100%;
      height: 310px;
    }
  }
}
</style>
<!--<style scoped>-->
<!--.t_container {-->
<!--  height: 70vh !important;-->
<!--  margin-bottom: 20 !important;-->
<!--}-->
<!--</style>-->
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table style="margin-bottom: 32px" v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/wo_report_record_analyse" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--                :ids.sync="yt.conditions.equipmentId">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialId"> </yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_matter_list'"-->
            <!--                :ids.sync="yt.conditions.materialId">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button
              @click="
                yt.clear({ status: [6]});
                reset();
              "
              >{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #shifoubulu="scope">
        <span v-if="scope.row.type == 0">
          {{ $t('fou') }}
        </span>
        <span v-if="scope.row.type == 1">
          {{ $t('shi') }}
        </span>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #footer_bottom>
        <div class="wrap">
          <div class="left">
            <div class="item1">
              <span class="icon"></span>
              <span class="txt">{{ $t('fenxijieguo') }}</span>
            </div>
            <div class="item2">
              <div class="header">
                <span class="title">{{ $t('buliangyuanyinpaiming') }}</span>
                <span class="circle"></span>
                <span class="tag-left">{{ $t('yibaogongbuliangshuliang') }}</span>
                <span class="circle" style="background: #F56C6C"></span>
                <span class="tag-right">{{ $t('zhanbi') }}</span>
              </div>

              <div v-if="resultList.length !== 0" class="reason">
                <div v-for="(item, index) in resultList" :key="index" class="reason__item">
                  <div class="content">
                    <div class="sort">{{ index + 1 }}</div>
                    <div class="title">{{ item.desc }}</div>
                    <div class="chart" :style="{ width: percent(item.badQuantity) }"></div>
                    <div class="label">
                      <span class="label-l">{{ item.badQuantity }} {{ $t('jian') }}</span>
                      <span class="label-r">{{ Number(item.badQuantityRate * 100).toFixed(1) }} %</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else style="font-size: 16px;display: flex;justify-content: center;align-items: center;margin-top: 100px;color:#606266;">{{ $t('zanwushujv') }}</div>
            </div>
          </div>
          <div class="right">
            <div class="item2">
              <div class="header">
                {{ $t('fenxitu') }}
              </div>
              <div v-show="resultList.length == 0" style="font-size: 16px;display: flex;justify-content: center;align-items: center;margin-top:100px;color:#606266;">{{ $t('zanwushujv') }}</div>
              <div id="tableChart"></div>
              <!--              resultList.length !==0-->
            </div>
          </div>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_report_bad_cause_list',
  data() {
    return {
      list: [],
      tab: [],
      num: '',
      allNumber: '',
      causeReportCharts: null,
      defectCodeName: [],
      topActive: '',
      codeName: null,
      procedureName: null,
      equipmentId: null,
      equipmentList: [],
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 130
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mouldNo',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mouldName',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'materialCode',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName',
          width: 130
        },
        {
          label: 'gongxumiaoshu',
          prop: 'procedureDesc',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity'
        },
        {
          label: 'baogongshuliang',
          prop: 'quantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130
        },

        {
          label: 'yibaogongbuliangpinshu',
          prop: 'badQuantity',
          width: 130
        },
        {
          label: 'shengyushengchanshuliang',
          prop: 'leftProductionQuantity',
          width: 130
        }
      ],
      resultList: []
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1, this.beforeGet);
      this.yt.conditions = {
        status: ['6']
      };
    }, 300);
  },
  mounted() {
    this.resize();
    // this.getAnalyseSummary()
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  computed: {
    percent() {
      return count => {
        let max = 0;
        for (let i = 0; i < this.resultList.length; i++) {
          if (this.resultList[i].badQuantity > max) {
            max = this.resultList[i].badQuantity;
          }
        }
        console.log('fffff1122', this.resultList);
        return (count / max) * 100 + '%';
      };
    }
  },

  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.screenWidth = document.body.clientWidth;
        if (this.causeReportCharts != null) {
          this.causeReportCharts.resize();
        }
      }, 500);
    },
    reset() {
      this.drawTableChart();
      this.yt.conditions = {
        status: ['6'],
        // orderBy: 'sort,woNo asc'
      };
      this.yt.get(1, this.beforeGet);
      this.resultList = [];
    },
    beforeGet(params) {
      // params['orderBy'] = 'sort,woNo asc';
      params['status'] = ['6'];
      return params;
    },
    selectionChange(items) {
      const arr = items.filter(item => item.badQuantity !== 0);
      this.allNumber = arr.reduce((total, item) => {
        return total + item.badQuantity;
      }, 0);
      this.drawTableChart();
      const idList = items.map(item => {
        return item.id;
      });
      console.log('ffffffffffd', idList);
      return this.http
        .get('/web/report/page/wo_report_bad_quantity_record_analyse_summary', {
          params: {
            orderBy: 'badQuantity desc',
            id: idList.join(',')
          }
        })
        .then(response => {
          if (response.data.rows.length > 0) {
            for (let i = 0; i < response.data.rows.length; i++) {
              if (response.data.rows[i]['desc'] === null) {
                response.data.rows[i]['desc'] = '未知';
              }
            }
          }
          this.resultList = response.data.rows;
          // if(this.resultList.length !==0){
          //
          // }
          // 已报工不良数量-所有的不良原因数量总和=未录入不良原因
          const num = this.resultList.filter(item => item.badQuantity !== 0);
          const allNum = num.reduce((total, item) => {
            return total + item.badQuantity;
          }, 0);
          const badQuantity = this.allNumber - allNum;
          if (badQuantity !== 0) {
            const dataList = {
              badQuantity: badQuantity,
              badQuantityRate: '',
              customerId: 12287,
              desc: '未录入原因'
            };
            this.resultList.push(dataList);
          }

          const rate = this.resultList.filter(item => item.badQuantity !== 0);
          const rateNum = rate.reduce((total, item) => {
            return total + item.badQuantity;
          }, 0);
          if (rateNum !== 0) {
            for (let i = 0; i < this.resultList.length; i++) {
              this.resultList[i]['badQuantityRate'] = this.resultList[i]['badQuantity'] / rateNum;
            }
          }

          this.resultList.sort((a, b) => b.badQuantity - a.badQuantity);
          this.drawTableChart(this.resultList);
        });
    },
    drawTableChart(data = []) {
      this.causeReportCharts = this.echarts.getInstanceByDom(document.getElementById('tableChart'));
      if (this.causeReportCharts == null) {
        this.causeReportCharts = this.echarts.init(document.getElementById('tableChart'));
      }
      if (data.length === 0) {
        this.causeReportCharts.dispose();
        return true;
      }
      let xAxis = data.map(item => {
        return item.desc;
      });
      let lData = data.map(item => {
        return item.badQuantity;
      });
      let rData = data.map(item => {
        return (item.badQuantityRate * 100).toFixed(1);
      });
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          left: 'center',
          top: '0%',
          textStyle: {
            color: '#909399',
            fontSize: 12
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '60',
          top: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          data: xAxis
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: false
            },
            nameLocation: 'middle',
            nameGap: 70
          },
          {
            type: 'value',
            name: '占比',
            nameLocation: 'start',
            max: 100,
            min: 0,
            interval: 20,
            splitLine: {
              show: false
            },
            axisLabel: {
              color: '#4e5b5f',
              formatter: function(val) {
                return val + '%';
              }
            }
          },
          {
            type: 'value',
            max: 100, //最大值
            min: 0, //最小值
            interval: 20, //间隔
            axisLine: {
              show: false,
              lineStyle: {
                color: '#d9e1e4'
              }
            },
            axisLabel: {
              color: '#4e5b5f',
              formatter: function(val) {
                //百分比显示
                return val + '%';
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            name: '不良数量',
            type: 'bar',
            barWidth: '12px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#419FFF'
                  },
                  {
                    offset: 1,
                    color: 'rgba(227, 227, 227,0.3)'
                  }
                ]),
                barBorderRadius: 6
              }
            },
            barGap: '80%',
            barCategoryGap: '100%',
            data: lData
          },

          {
            name: '占比',
            type: 'line',
            showSymbol: false,
            symbol: 'none',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function(value) {
                return value + ' %';
              }
            },
            lineStyle: {
              color: '#E6A23C'
            },
            itemStyle: {
              color: '#E6A23C'
            },
            color: '#E6A23C',
            // label: {
            //   position: [-35, -20],
            //   show: true,
            //   fontSize: 14,
            //   color: '#FC8452'
            // },
            data: rData
          }
        ]
      };
      this.causeReportCharts.setOption(option);
    },
    beforeAdd(params, url) {
      console.log('params', params);
      params.reportRecordId = params.id;
      params.defectCodeList = [];
      let levelOneDefectTypeId = this.tab
        .map(item => {
          return item.id;
        })
        .join(',');
      params['levelOneDefectTypeId'] = parseInt(levelOneDefectTypeId);
      if (this.tab.length > 0) {
        for (let i = 0; i < this.tab.length; i++) {
          let all = this.tab[i]['defectCodeVOS'];
          for (let j = 0; j < all.length; j++) {
            let defectCodeId = all[j]['id'];
            let defectDesc = all[j]['desc'];
            let badQuantity = all[j]['badQuantity'];
            let allItem = {
              defectCodeId: defectCodeId,
              defectDesc: defectDesc,
              defectCodeBadQuantity: badQuantity == null || badQuantity == undefined ? 0 : badQuantity
            };
            params.defectCodeList.push(allItem);
          }
          // params.levelOneDefectTypeId.push(this.tab[i]['id'])
        }
      }
      return params;
    },
    handleClick(tab, event) {
      // this.topActive = this.defectCodeName[0]['desc']
      console.log('tabtab', tab);
      console.log('eventevent', event);
      // this.topActive = tab
    },
    getEquipmentId() {
      this.http
        .get('/web/setting/shift/getShiftByEquipmentId', {
          params: {
            equipmentId: this.equipmentId,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.equipmentList = res.data;
          console.log('kkkk', this.equipmentList);
        });
    },
    // /basic/defectType/getDefectTypeAndCode
    getDefectTab() {
      this.http
        .get('/web/basic/defectType/getDefectTypeAndCode', {
          params: {
            level: 1
          }
        })
        .then(res => {
          this.tab = res.data || [];
          this.tab.forEach((val, index, val_arr) => {
            if (val_arr[index].defectCodeVOS.length != 0 && val_arr[index].defectCodeVOS != []) {
              val_arr[index].defectCodeVOS.forEach((el, i, el_arr) => {
                this.defectCodeName = el_arr;
              });
            }
          });
          console.log('44444', this.defectCodeName);
          if (!this.tab.length == '') {
            this.topActive = this.tab[0]['name'];
          }
          console.log('ddddd', this.tab);
        });
    },
    beforeShowEditDialog(editObj) {
      this.equipmentId = editObj.equipmentId;
      this.procedureName = editObj.procedureCode + ' / ' + editObj.procedureDesc;
      return editObj;
    },
    exportExcel() {
      let params = this.yt.conditions;
      return this.http
        .get('/web/report/page/wo_report_record_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()).getTime();
      return end;
    },
    // 重置
    clear() {
      this.yt.conditions = {
        createTimeStart: this.begin(),
        createTimeEnd: this.end()
      };
      this.yt.list = [];
    }
  }
};
</script>
